<template>
  <div v-if="errorFetchingExtensionSchema">
    <vs-alert type="warn">Failed to load {{ label }} fields</vs-alert>
    <vs-button label="Try again" type="tertiary" @click="retryFetchingExtensionSchema" />
  </div>
  <div v-else>
    <vs-heading type="overline" class="pb-2"> Loading {{ label }} fields... </vs-heading>
    <v-progress-linear
      class="ma-auto progress-center"
      :size="64"
      :width="6"
      indeterminate
      color="primary"
    />
  </div>
</template>

<script setup lang="ts">
import VsAlert from '@/components/vision/VsAlert.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import { computed } from 'vue'

const props = defineProps<{
  errorFetchingExtensionSchema: any
  name?: string | undefined
}>()

const emit = defineEmits<{
  (e: 'retry'): void
}>()

const label = computed(() => props.name ?? 'activity')

const retryFetchingExtensionSchema = () => {
  emit('retry')
}
</script>

<style scoped>
.progress-center {
  margin: auto;
}
</style>
